;(() => {
  const grid = document.querySelector('.games-grid')
  const loadMoreGamesButton = document.querySelector('.load-more-games')

  if (grid && loadMoreGamesButton) {
    loadMoreGamesButton.addEventListener('click', () => {
      const page = parseInt(grid.dataset.page)
      const perPage = parseInt(grid.dataset.perPage)
      const totalGames = parseInt(grid.dataset.total)
      const style = parseInt(grid.dataset.style)

      const params = new URLSearchParams()
      params.append('action', 'load-more-games')
      params.append('per_page', perPage)
      params.append('page', page)
      params.append('style', style)

      window
        .fetch(SpinokoFrontEnd.ajaxUrl, {
          // eslint-disable-line
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
          body: params,
        })
        .then((response) => response.json())
        .then((result) => {
          if (result.games.length) {
            grid.innerHTML += result.games.join('')
            grid.dataset.page = result.page

            if (result.page * perPage >= totalGames) {
              loadMoreGamesButton.parentElement.removeChild(loadMoreGamesButton)
            }

            const listingId = grid.parentElement.dataset.listingId || ''
            const listingTools = document.querySelector(`[data-id="${listingId}"]`)
            if (listingTools) {
              listingTools.dataset.items = `${listingTools.dataset.items || ''},${result.game_ids.join(',')}`
            }
          } else {
            // we should never get here, but just in case 👽
            grid.innerHTML += '<p class="sp-mt-4 text-lg font-bold text-body">No games found.</p>'
            loadMoreGamesButton.parentElement.removeChild(loadMoreGamesButton)
          }
        })
    })
  }
})()
